import { DEFAULT_FONTSIZE } from "../../utils/utils";
import PsychoeducationSection from "../_shared/PsychoeducationSection";
import AllergiesBlock from "../_shared/AllergiesBlock";
import HistoryBlock from "../_shared/HistoryBlock";
import MedicationsBlock from "../_shared/MedicationsBlock";
import VitalsBlock from "../_shared/VitalsBlock";
import RosBlock from "../_shared/RosBlock";
import PhysicalExamBlock from "../_shared/PhysicalExamBlock";
import ScreeningAssessmentBlock from "../_shared/ScreeningAssessmentBlock";
import AssessmentBlock from "../_shared/AssessmentBlock";
import PrescriptionsBlock from "../_shared/PrescriptionsBlock";
import VaccinesBlock from "../_shared/VaccinesBlock";
import CptCodesBlock from "../_shared/CptCodesBlock";
import {
  CarePlanTemplateList,
  KeyValPair,
  OrderList,
  RenderTextWithContainerPattern,
  ReportSection,
  SectionHead,
} from "../constant";

interface TreatmentPlanTemplateProps {
  data: any;
}

const TreatmentPlanTemplate = ({ data }: TreatmentPlanTemplateProps) => {
  return (
    <>
      <SectionHead
        label="Treatment Plan"
        color="#FAF0E6"
        fontSize={DEFAULT_FONTSIZE.fontSize}
        borderTop={false}
      />

      {/* ── Subjective ── */}
      <ReportSection label="Subjective">
        <RenderTextWithContainerPattern
          label="History of Present Illness"
          val={data?.historyOfPresentIllness}
        />
        <RenderTextWithContainerPattern
          label="Subjective"
          val={data?.subjectiveFreeNote}
        />
        <RenderTextWithContainerPattern label="Problems" val={data?.problems} />
        <RenderTextWithContainerPattern
          label="Treatment Goal"
          val={data?.treatmentGoal}
        />
        <RenderTextWithContainerPattern
          label="Treatment Strategy/Intervention"
          val={data?.treatmentStrategy}
        />
        <RenderTextWithContainerPattern
          label="Prescribed Frequency for Treatment"
          val={data?.frequencyOfTreatment}
        />
        {data?.estimateCompletionOfTreatmentGoal && (
          <KeyValPair
            k="Treatment Goals Estimated Completion"
            v={data?.estimateCompletionOfTreatmentGoal ?? "-"}
          />
        )}
        {data?.estimateCompletionOfTreatmentStrategy && (
          <KeyValPair
            k="Treatment Strategy/Intervention Estimated Completion"
            v={data?.estimateCompletionOfTreatmentStrategy ?? "-"}
          />
        )}
        <AllergiesBlock data={data} />
        <HistoryBlock data={data} />
        <RenderTextWithContainerPattern label="Habits" val={data?.habits} />
        <MedicationsBlock data={data} />
      </ReportSection>

      {/* ── Objective ── */}
      <ReportSection label="Objective">
        <RenderTextWithContainerPattern
          label="Objective"
          val={data?.objectiveFreeNote}
        />
        <VitalsBlock data={data} />
        <PhysicalExamBlock data={data} />
        <RosBlock data={data} />
        <ScreeningAssessmentBlock data={data} />
      </ReportSection>

      {/* ── Assessment ── */}
      <ReportSection label="Assessment">
        <AssessmentBlock data={data} />
      </ReportSection>

      {/* ── Plan ── */}
      <ReportSection label="Plan">
        <RenderTextWithContainerPattern label="Plan" val={data?.planFreeNote} />
        <PrescriptionsBlock data={data} />
        <VaccinesBlock data={data} />
        <OrderList orders={data?.patientOrders} />
        <CptCodesBlock data={data} />
        <RenderTextWithContainerPattern
          label="Care Plan"
          val={data?.carePlan}
        />
        <CarePlanTemplateList carePlanTemplates={data?.carePlanTemplates} />
        <RenderTextWithContainerPattern
          label="Instructions"
          val={data?.instruction}
        />

        <KeyValPair
          k="I Declare That These Services Are Medically Necessary And Appropriate To The Recipient's Diagnosis And Needs."
          v={
            data?.agreedToTreatmentPlan ? " Yes I Agree" : " No I Do Not Agree"
          }
        />
      </ReportSection>

      {/* ── Follow-Up ── */}
      <ReportSection label="Follow-Up">
        <RenderTextWithContainerPattern
          label="Follow Up"
          val={data?.followUp}
        />

        {/* ── Psychoeducation Session (shown below Follow Up only when required) ── */}
        <PsychoeducationSection data={data} />
      </ReportSection>
    </>
  );
};

export default TreatmentPlanTemplate;
